// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1TNFz","title":"ClientCherryInfo_title__39bm9","itemText":"ClientCherryInfo_itemText__3mV_F"};